import { Toggle } from '@kcftech/design-system';
import { Setting } from 'components/node_settings/V4Settings/Setting';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const ToggleCell = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;

    --toggle-checked-background: ${tokens.success.default};
`;

type ToggleSettingProps = Readonly<{
    name: ReactNode;
    ariaLabel: string;
    helperText?: ReactNode;
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
}>;

export function ToggleSetting({
    name,
    ariaLabel,
    helperText,
    checked,
    disabled = false,
    onChange,
}: ToggleSettingProps) {
    return (
        <Setting name={name} helperText={helperText}>
            <ToggleCell>
                <Toggle
                    ariaLabel={ariaLabel}
                    checked={checked}
                    disabled={disabled}
                    onChange={onChange}
                />
            </ToggleCell>
        </Setting>
    );
}
